import type {SiteBeReadyUser, SiteBetriebUser, SiteInvestUser, SiteLoginState, SiteResearchUser, SiteSocialUser} from 'app/components/header/profile/interface';
import type {NamedSetState} from 'app/gemStore/devtools';

import type {SiteLoginSlice} from './types';

const siteLoginInitialState: SiteLoginState = {
    researchUser: null,
    socialUser: null,
    betriebUser: null,
    investUser: null,
    beReadyUser: null,
};

export const createSiteLoginSlice = (set: NamedSetState<SiteLoginSlice>, get: () => SiteLoginSlice) => ({
    siteLogin: siteLoginInitialState,
    setSocialUser: (socialUser: SiteSocialUser) => {
        set({siteLogin: {...get().siteLogin, socialUser}}, false, 'siteLogin/setSocialUser');
    },
    unsetSocialUser: () => {
        set({siteLogin: {...get().siteLogin, socialUser: null}}, false, 'siteLogin/unsetSocialUser');
    },
    setResearchUser: (researchUser: SiteResearchUser) => {
        set({siteLogin: {...get().siteLogin, researchUser}}, false, 'siteLogin/setResearchUser');
    },
    unsetResearchUser: () => {
        set({siteLogin: {...get().siteLogin, researchUser: null}}, false, 'siteLogin/unsetResearchUser');
    },
    setBetriebUser: (betriebUser: SiteBetriebUser) => {
        set({siteLogin: {...get().siteLogin, betriebUser}}, false, 'siteLogin/setBetriebUser');
    },
    unsetBetriebUser: () => {
        set({siteLogin: {...get().siteLogin, betriebUser: null}}, false, 'siteLogin/unsetBetriebUser');
    },
    setInvestUser: (investUser: SiteInvestUser) => {
        set({siteLogin: {...get().siteLogin, investUser}}, false, 'siteLogin/setInvestUser');
    },
    unsetInvestUser: () => {
        set({siteLogin: {...get().siteLogin, investUser: null}}, false, 'siteLogin/unsetInvestUser');
    },
    setBeReadyUser: (beReadyUser: SiteBeReadyUser) => {
        set({siteLogin: {...get().siteLogin, beReadyUser}}, false, 'siteLogin/setBeReadyUser');
    },
    unsetBeReadyUser: () => {
        set({siteLogin: {...get().siteLogin, beReadyUser: null}}, false, 'siteLogin/unsetBeReadyUser');
    },
});
